import { Asset } from '../assetLab/api';
import { CaFbProject } from './model';
import { CHNode } from './node';

export const urlLocalizationZip = (projectID: CaFbProject['crhub_project_id']) =>
  `/api/crhub/bl/projects/${projectID}/localization/zip`;

export const urlThumbnail = (nodeId: number) => `/api/crhub/preview/thumbnails/${nodeId}`;

export const urlZip = (nodeIds: number[]) => `/api/crhub/fs/zip?ids=${nodeIds.join()}`;

export const urlZipShare = (shareId: string, nodeIds: number[]) =>
  `/api/crhub/fs/sharing/${shareId}/zip?ids=${nodeIds.join()}`;

export const urlArchive = (node_id: number, file_path: string) =>
  `/api/crhub/fs/archive/${node_id}/${file_path}`;

export const urlArchiveShare = (node_id: number, file_path: string, shareID: string) =>
  `/api/crhub/fs/sharing/${shareID}/archive/${node_id}/${file_path}`;

export const urlDownloadFile = (node_id: number) => `/api/fd/fs/download_file?node_id=${node_id}`;

export const urlDownloadShare = (shareId: string, nodeId: number) =>
  `/api/fd/fs/sharing/${shareId}/download?node_id=${nodeId}`;

// urls suitable for generatePath

export const hubRoutes = {
  folder: '/folder/:nodeId',
  file: '/folder/:folderID/:fileID',
  folderExternal: 'creative_hub.html#/folder/:folderID',
  // Корень Creative Hub из соседнего SPA. Относительный путь, как у остальных
  // `*External`: все пять точек входа лежат в одной статической директории.
  rootExternal: 'creative_hub.html#/',
  adminCore: 'creative_admin.html#/core_directory',
  fileExternal: 'creative_hub.html#/folder/:folderID/:fileID',
  sharedLinks: '/shared_links',
  moderation: '/moderation/', // страница модерации лицензий юристом (MYUA-16456)
  trash: '/trash/',
  locate: '/locate/:fileID',
  locateExternal: 'creative_hub.html#/locate/:fileID',
  trashFile: '/trash/:fileID',
  favorites: '/favorites',
  filePreview: '/file_preview/:nodeId/:fileID',
  root: '/',
  search: '/search', // ?q=term&global=1&scope=123
} as const;
// Deep link into Asset Lab's Catalog with project + category pre-applied.
// Asset Lab Project.id and Category.id are the same ids as the Creative Hub
// project-folder and category-folder node ids. Params go BEFORE the hash so that
// `new URL(href).searchParams` reads them (same mechanism as state_id).
export const assetLabExternalURL = (
  projectId: number | string,
  categoryId?: string | null,
  assetId?: number | string | null,
) => {
  const params = new URLSearchParams({ highlight_project_id: String(projectId) });
  if (categoryId) {
    params.set('highlight_category_id', categoryId);
  }
  if (assetId !== undefined && assetId !== null) {
    params.set('highlight_asset_id', String(assetId));
  }
  return `asset_lab.html?${params.toString()}#/viewer/`;
};

export const routerFolder = (
  folderId: string | number = '',
  shareId: string | null = null,
  fileID?: number | string,
) => {
  let path = shareId ? `/shared_folder/${shareId}` : `/folder`;
  if (folderId !== '') {
    const suffix = fileID ? `/${fileID}` : '';
    path += `/${folderId}${suffix}`;
  }
  return path;
};

// Streaming API

export const urlDownload = (props: { nodeID: number; shareID?: string; downloadURL?: string }) => {
  if (props.downloadURL) {
    const url = new URL(props.downloadURL);
    return url.href;
  }
  return props.shareID
    ? urlDownloadShare(props.shareID, props.nodeID)
    : urlDownloadFile(props.nodeID);
};

export function urlDirectDownload(
  nodeOrAsset:
    | Pick<CHNode, 'id' | 'can_download_direct' | 'direct_source'>
    | Pick<Asset, 'id' | 'can_create_direct_download_link'>,
  shareID?: string | null,
) {
  if ('can_create_direct_download_link' in nodeOrAsset) {
    // asset lab
    if (nodeOrAsset.can_create_direct_download_link) {
      return shareID
        ? `/api/asset-lab/sharing/assets/${nodeOrAsset.id}/direct-link?sharing_id=${shareID}`
        : `/api/asset-lab/assets/${nodeOrAsset.id}/direct-link`;
    } else return null;
  }
  if ('can_download_direct' in nodeOrAsset) {
    // creative hub
    if (nodeOrAsset.can_download_direct && nodeOrAsset.direct_source === 'GOOGLE') {
      return shareID
        ? `/api/crhub/fs/sharing/${shareID}/download_direct?node_id=${nodeOrAsset.id}`
        : `/api/crhub/fs/download_file_direct?node_id=${nodeOrAsset.id}`;
    } else return null;
  }
  nodeOrAsset satisfies never;
  return null;
}
export const urlStreaming = (props: { nodeID: number; shareId?: string; previewURL?: string }) => {
  if (props.previewURL) {
    const url = new URL(props.previewURL);

    return url.href;
  }

  return props.shareId
    ? `/api/fd/fs/sharing/${props.shareId}/stream/${props.nodeID}`
    : `/api/fd/fs/stream/${props.nodeID}`;
};

// Preview API

export const urlCompressedTreeProvider = (nodeID: number, sharingID?: string) =>
  `/api/crhub/fs/${sharingID !== undefined ? `sharing/${sharingID}/` : ''}archive/${nodeID}`;

export const urlReadDoc = (nodeId: number) => `/api/crhub/fs/read-doc/${nodeId}`;
